import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PolteqTextField = _resolveComponent("PolteqTextField")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_PolteqButton = _resolveComponent("PolteqButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    id: "signUpForm",
    ref: "signUpForm",
    onsubmit: "validate"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { style: {"height":"320px","overflow-y":"scroll","overflow-x":"hidden","flex-grow":"1"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_PolteqTextField, {
                    modelValue: _ctx.firstname,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                    "field-id": "firstNameField",
                    label: _ctx.i18n.t('fields.firstName'),
                    rules: [_ctx.rules.required],
                    type: "text"
                  }, null, 8, ["modelValue", "label", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_PolteqTextField, {
                    modelValue: _ctx.lastname,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastname) = $event)),
                    "field-id": "lastNameField",
                    label: _ctx.i18n.t('fields.lastName'),
                    rules: [_ctx.rules.required],
                    type: "text"
                  }, null, 8, ["modelValue", "label", "rules"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.company,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company) = $event)),
            "field-id": "companyNameField",
            label: _ctx.i18n.t('fields.company'),
            type: "text"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.emailaddress,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailaddress) = $event)),
            "field-id": "emailAddressField",
            label: _ctx.i18n.t('fields.emailaddress'),
            rules: [_ctx.rules.required, _ctx.rules.email],
            type: "email",
            autocomplete: "username"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.phonenumber,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phonenumber) = $event)),
            "field-id": "phoneNumberField",
            label: _ctx.i18n.t('fields.phonenumber'),
            rules: [_ctx.rules.phone_number],
            type: "tel",
            autocomplete: "phonenumber"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.newpassword,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newpassword) = $event)),
            "field-id": "passwordField",
            label: _ctx.i18n.t('fields.password'),
            rules: [_ctx.rules.password],
            type: "password",
            autocomplete: "new-password"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(_component_PolteqTextField, {
            modelValue: _ctx.confirm,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirm) = $event)),
            "field-id": "confirmPasswordField",
            label: _ctx.i18n.t('fields.confirmpassword'),
            rules: [_ctx.rules.password_match(_ctx.newpassword, _ctx.confirm)],
            type: "password",
            autocomplete: "new-password"
          }, null, 8, ["modelValue", "label", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { style: {"text-align":"end"} }, {
        default: _withCtx(() => [
          _createVNode(_component_PolteqButton, {
            "button-id": "signUpButton",
            icon: "mdi-account-plus-outline",
            "button-text": _ctx.i18n.t('buttons.signup'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.signUp(_ctx.firstname, _ctx.lastname, _ctx.company, _ctx.emailaddress, _ctx.phonenumber, _ctx.newpassword)))
          }, null, 8, ["button-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}